var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon is-large",attrs:{"href":_vm.url,"target":"_blank"}},[_c('fa',{attrs:{"icon":['fab', 'linkedin'],"size":"2x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }